import styled from "styled-components";

import infoTilteBgSrc from "../../../../image/home/info-tilte-background.svg";
import goldenBulletSrc from "../../../../image/home/golden-bullet.svg";
import rightCurveImage from "../../../../image/home/right-curve-image.svg";
import leftCurveImage from "../../../../image/home/left-curve-image.svg";
import zigzagShapeImgSrc from "../../../../image/assets/zigzag-shape.svg";

export const StlyedSection = styled.section`
  padding: 6.5rem 0;
  position: relative;
  background: url(${zigzagShapeImgSrc}) no-repeat 5% 10%;
  &::before {
    content: "";
    background: url(${rightCurveImage}) no-repeat;
    width: 174px;
    height: 108px;
    position: absolute;
    right: 0;
    top: 100px;
  }
  &::after {
    content: "";
    background: url(${leftCurveImage}) no-repeat;
    width: 174px;
    height: 108px;
    position: absolute;
    left: 0;
    bottom: 50px;
  }
  @media screen and (max-width: 576px) {
    padding: 3rem 0;
    background-size: 60px;
    background-position-y: 180px;
    &::before {
      top: 380px;
      background-size: 80px;
      background-position-x: right;
      transform: skewY(345deg);
    }
    &::after {
      content: "";
      background-size: 80px;
      background-position-x: left;
      bottom: 15px;
    }
  }
`;

export const InfoSecImg = styled.img`
  @media screen and (max-width: 576px) {
    max-width: 185px;
  }
`;

export const Heading = styled.h3`
  padding: 2rem 1rem;
  font-size: 32px;
  font-weight: 700;
  background: url(${infoTilteBgSrc}) no-repeat center;
  background-size: contain;
  text-align: center;
  @media screen and (max-width: 576px) {
    padding: 1.5rem;
    font-size: var(--font-size-lg);
  }
  strong {
    span:nth-child(1) {
      color: var(--secondary-color);
    }
    span:nth-child(2) {
      color: var(--primary-color);
    }
  }
`;

export const ListImgWrapper = styled.div`
  z-index: 1;
  width: 80px;
  .center-icon {
    position: absolute;
    right: -20px;
    top: 3px;
    width: fit-content;
  }
  @media screen and (max-width: 576px) {
    width: 45px;
    img {
      width: 29px;
      height: fit-content;
      &.center-icon {
        right: -12px;
        top: 16px;
        width: 36px;

        /* height: 25px; */
      }
    }
  }
  &::before {
    content: "";
    position: absolute;
    background: url(${goldenBulletSrc}) no-repeat;
    width: 47px;
    height: 47px;
    top: 10px;
    right: -15px;
    z-index: -1;
    @media screen and (max-width: 576px) {
      background-size: contain;
      top: 19px;
      right: -8px;
      width: 26px;
      height: 26px;
    }
  }
`;

export const ListItemContent = styled.div`
  font-weight: 500;
  h5 {
    color: var(--text-color-dark);
  }
  p {
    color: var(--deactive-color);
    max-width: 390px;
  }
  @media screen and (max-width: 576px) {
    h5 {
      font-size: var(--font-size-base);
    }
    p {
      font-size: var(--font-size-xs);
      max-width: 280px;
    }
  }
`;
